export enum Unit {
  Px,
  Em,
  Rem,
}

export function pixelsToUnit(value: number, unit: Unit = Unit.Px) {
  return unit === Unit.Px ? `${value}px` : `${value / 16}${unit === Unit.Rem ? 'rem' : 'em'}`;
}
